export const AppRoutes = {
  ROOT: "",
  LOGIN: "login",
  CHARTERS: "charters",
  VILLA_RESERVATIONS: "villa-reservations",
  PACKERS: "packers",
  PROVIDERS: "providers",
  ASSETS: "assets",
  CUSTOMERS: "customers",
  ORDERS: "orders",
  ZONES: "zones",
  AGENCIES: "agencies",
  STOREFRONT_CONFIG: "storefront-config",
  SETTINGS: "settings",
};

export const KEYCLOAK_CLIENT_ID = "xdrop-admin";

export const SHOPIFY_SHOP_ID = "938713";
export const SHOPIFY_SHOP_NAME = "quickstart-973ccb89";
export const ADMIN_STORE_URL = `https://admin.shopify.com/store/${SHOPIFY_SHOP_NAME}`;

export enum BUSINESS_UNIT {
  YACHT = "YACHT",
  VILLA = "VILLA",
  CHALET = "CHALET",
}

export enum NOTIFICATION_CHANNEL {
  Email = "EMAIL",
  Sms = "SMS",
}

export enum FILTER_ENTITIES {
  Reservation = "Reservation",
  Assets = "Assets",
  Customers = "Customers",
  Orders = "Orders",
  PackOrders = "PackOrders",
  ProviderOrders = "ProviderOrders",
  Agencies = "Agencies",
  Zones = "Zones",
}

export enum DATE_FILTERS {
  Today = "Today",
  Tomorrow = "Tomorrow",
  Yesterday = "Yesterday",
}

export enum OrderStatus {
  CREATED = "CREATED",
  PENDING = "PENDING",
  CONFIRMED = "CONFIRMED",
  FULFILLED = "FULFILLED",
  DELIVERED = "DELIVERED",
  COLLECTED = "COLLECTED",
  CANCELLED = "CANCELLED",
}

export enum FulfillmentStatus {
  CREATED = "CREATED",
  CONFIRMED = "CONFIRMED",
  CANCELLED = "CANCELLED",
}

export const DROPOFF_TIME_SLOTS = ["10h - 12h", "12h - 14h", "14h - 16h", "16h - 18h", "20h - 22h"];

export const CHECKOUT_TIMES = [
  "07:00",
  "07:30",
  "08:00",
  "08:30",
  "09:00",
  "09:30",
  "10:00",
  "10:30",
  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
  "14:00",
  "14:30",
  "15:00",
  "15:30",
  "16:00",
  "16:30",
  "17:00",
  "17:30",
  "18:00",
  "18:30",
  "19:00",
  "19:30",
  "20:00",
];

export const PAGINATION_CONFIG = {
  DEFAULT_PAGE_SIZE: 25,
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
  DEFAULT_CURRENT_PAGE: 1,
};

// Re-export countries data for convenience
export type { Country } from "./countries";
export { COUNTRIES, getFlagUrl, getDefaultCountry } from "./countries";
